// NetworkApi converts an empty/null result to {}; only a real permission
// belonging to the current applicant and selected parcel may trigger renewal.
export function isPreviousFarmlandUsage(usage: any, farmlandId: any, organizationId: any): boolean {
  return !!usage && Number.isInteger(Number(usage.id)) && Number(usage.id) > 0 &&
    Number(organizationId) > 0 && Number(farmlandId) > 0 &&
    Number(usage.organizationId) === Number(organizationId) &&
    Number(usage.farmlandId) === Number(farmlandId) && usage.status === "expired";
}
